import { render, staticRenderFns } from "./ConferenceManagement.vue?vue&type=template&id=65d269ba&scoped=true"
import script from "./ConferenceManagement.vue?vue&type=script&lang=ts"
export * from "./ConferenceManagement.vue?vue&type=script&lang=ts"
import style0 from "./ConferenceManagement.vue?vue&type=style&index=0&id=65d269ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d269ba",
  null
  
)

export default component.exports